import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';


/** import all components */
import Username from './components/Username';
import Password from './components/Password';
import Register from './components/Register';
import Profile from './components/Profile';
import Recovery from './components/Recovery';
import Reset from './components/Reset';
import PageNotFound from './components/PageNotFound';
import Report from './components/Report/Report';
import WebHookReport from './components/Report/WebHookReport';
import Report1 from './components/Report/Report1';
import Report2 from './components/Report/Report2';
import Report3 from './components/Report/Report3';



import { useAuthStore } from './store/store';



/** auth middleware */
import { AuthorizeUser, ProtectRoute } from './middleware/auth'
import { RoleBasedRoute } from './middleware/role'
import Login from './components/Login';
import Dashboard from './components/Dashboard/Dashboard';
import ImeiFinder from './components/ImeiFinder/ImeiFinder';
import DeviceReports from './components/DeviceReports/DeviceReports';
import WebHookDeviceReports from './components/DeviceReports/WebHookDeviceReports';
import CustomPage from './ghlcustom-page/Custom-page';
import LiveReport from './components/Report/LiveReport';
import ImeiScript from './components/ImeiFinder/ImeiScript';
import GradeCompareReports from './components/DeviceReports/GradeCompareReports';
import GhlPage from './ghlcustom-page/GhlPage';
import PromoCodeManagement from './components/stripe/PromoCodeManagement';

/** root routes */
const router = createBrowserRouter([
    {
        path : '/',
        element : <Login></Login>
    },
    {
        path : '/marketplace',
        element : <GhlPage/>
    },
    {
        path : '/register',
        element : <Register></Register>
    },
    {
        path : '/password',
        element : <ProtectRoute><Password /></ProtectRoute>
    },
    {
        path : '/profile',
        element : <AuthorizeUser><Profile /></AuthorizeUser>
    },
    {
        path : '/recovery',
        element : <Recovery></Recovery>
    },
    {
        path : '/reset',
        element : <Reset></Reset>
    },
    {
        path : '*',
        element : <PageNotFound></PageNotFound>
    }, 
    // {
    //     path : '/report',
    //     element :<RoleBasedRoute allowedRoles={['admin']}> <Report /></RoleBasedRoute>
    // }, 
    {
        path : '/dashboard',
        element :<AuthorizeUser> <Dashboard /> </AuthorizeUser>
    }, 

    //Report Paths
    {
        path: '/report/:imei', 
        element: (
            <Report />
        ),
    },

    {
        path: '/webhook/report/:id', 
        element: (
            <WebHookReport />
        ),
    },

    {
        path: '/live-report/:imei', // Dummy Data Report 3
        element: (
            <LiveReport />
        ),
    },

    {
        path: '/report-1', // Dummy Data Report 1
        element: (
            <Report1 />
        ),
    },

    {
        path: '/report-2', // Dummy Data Report 2
        element: (
            <Report2 />
        ),
    },

    {
        path: '/report-3', // Dummy Data Report 3
        element: (
            <Report3 />
        ),
    },

    // Device Reports 
    {
        path: '/device-reports',
        element: (
            <AuthorizeUser><DeviceReports /></AuthorizeUser>
        ),
    },

    {
        path: '/all-reports',
        element: (
           <WebHookDeviceReports />
        ),
    },

    {
        path: '/grade-compare',
        element: (
            <AuthorizeUser><GradeCompareReports /></AuthorizeUser>
        ),
    },

    //IMEI Finder
    {
        path : '/imei-finder',
        element: <ImeiFinder />
    },
    {
        // path : '/imei-script',
        path : '/live-transactions',
        element: <ImeiScript />
    },
    {
        // path : '/imei-script',
        path : '/promocode-management',
        element: <PromoCodeManagement />
    },

])

export default function App() {
 return (
    <main>
        <RouterProvider router={router}></RouterProvider>
    </main>
  )
}
